export default __webpack_public_path__ + "static/media/cover-with-bg-desktop.461b1556.jpg";